import { render, staticRenderFns } from "./behaviour-biting-questions.vue?vue&type=template&id=5bdec5cd"
import script from "./behaviour-biting-questions.vue?vue&type=script&lang=js"
export * from "./behaviour-biting-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports